import { EventEmitter, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EMPTY, Observable, switchMap } from 'rxjs';
import { environment } from 'src/environments/environment';;
import { Provider, Providers } from 'src/models/Provider.interface';
import { DateRange } from 'src/models/DateRange.interface';
import { ProviderBill } from 'src/models/ProviderBill.interface';

@Injectable({
    providedIn: 'root',
})
export class ProvidersService {

    public rolEmitter: EventEmitter<string> = new EventEmitter();

    constructor(private http: HttpClient) { }

    getListProviders(page: number): Observable<Providers> {
        const url = `${environment.API_URL}/api/v1/providers?page=${page}`;
        return this.http.get<Providers>(url);
    }

    createProvider(newProvider: Provider): Observable<any> {
        const url = `${environment.API_URL}/api/v1/providers`;
        return this.http.post<Provider>(url, newProvider);
    }

    updateProvider(providerId: number, newFields: any): Observable<any> {
        const url = `${environment.API_URL}/api/v1/providers/${providerId}`;
        return this.http.patch<any>(url, newFields);
    }

    getProviderBillsByDateRange(
        providerName: string | number,
        dateRange: DateRange,
        page: number
    ): Observable<ProviderBill[]> {
        const startDateString = dateRange.startDate.toISOString().split('T')[0];
        const endDateString = dateRange.endDate.toISOString().split('T')[0];
        const url = `${environment.API_URL}/api/v1/providers?name=${providerName}`;
        return this.http.get<any[]>(url).pipe(
            switchMap((providers) => {
                if (providers.length === 0) {
                    return EMPTY;
                }
                const billsUrl = `${environment.API_URL}/api/v1/providers/${providerName}/bills/startDate/${startDateString}/endDate/${endDateString}?page=${page}`;
                return this.http.get<ProviderBill[]>(billsUrl);
            })
        );
    }
}

